import React from 'react'
import cn from 'classnames'
import styled from 'styled-components'

// app components
import Checkbox, { CheckboxProps } from './Checkbox'

export type CheckButtonProps = {
    name: string
    expand?: boolean
} & CheckboxProps

const CheckButtonUnstyled: React.FC<CheckButtonProps> = ({
    children,
    className,
    expand,
    ...props
}) => {
    const classes = cn(className, { 'check-btn-expand': !!expand })

    return (
        <Checkbox className={classes} {...props}>
            {children}
        </Checkbox>
    )
}

/**
 * Checkbox component that allows a child text as a label
 */
const CheckButton = styled(CheckButtonUnstyled)`
    &.custom-checkbox {
        && {
            min-height: auto;
            line-height: ${props => props.theme['$custom-checkbutton-indicator-size']};
            padding: ${props =>
                `${props.theme['$custom-checkbutton-spacer-y']} ${props.theme['$custom-checkbutton-spacer-x']}`};
            background: ${props => props.theme['$input-bg']};
        }
        border: ${props =>
            `${props.theme['$input-border-width']} solid ${props.theme['$input-bg']}`};

        &.custom-control-checked {
            border-color: ${props => props.theme['$custom-control-indicator-checked-border-color']};
        }

        &.check-btn-expand {
            width: 100%;
        }

        /* checkbox style */
        & .custom-control-indicator {
            position: relative;
            font-size: ${props => props.theme['$custom-checkbutton-indicator-size']};

            &:before {
                right: 0.45em;
                bottom: 2px;
            }
        }

        /* Styles base at checkbox state control */
        & .custom-control-input {
            &:focus {
                &:checked {
                    & ~ .custom-control-indicator {
                        box-shadow: none;
                        border-color: ${props =>
                            props.theme['$custom-control-indicator-focus-border-color']};
                    }
                }
            }
        }

        /* Styles for checkbox text label */
        & .custom-control-description {
        }
    }
`

export default CheckButton
